import { Navigate } from 'react-router-dom';
import { Header } from 'components/Header';
import { Box } from 'components/layout';
import { useAuth } from 'context/UserAuthContext';

export const Home = () => {
  const { loggedIn } = useAuth();
  if(loggedIn) {
    return <Navigate to='/ui' />
  }

  return (
    <Box>
      <Header />
      <Box className='App-header'>
        <p>Spedmeyer Home (not logged in)</p>
      </Box>
    </Box>
  )
};
